import {ENVIRONMENT_LEVEL} from '@/Constant';

interface MappingRule {
    match: string;
    replaceHost?: string;
    envs?: string;
    replaceHref?: [string, string];
    envsHost?: string;
    envsReplace?: string;
}

const reverseMappings: MappingRule[] = [
    {
        match: 'ku.baidu-int.com',
        replaceHost: 'ku.baidu.com',
        envs: ENVIRONMENT_LEVEL.gray,
        envsHost: 'kugray.baidu.com',
    },
    {
        match: 'wikigray.baidu-int.com',
        replaceHost: 'kugray.baidu.com',
        envs: ENVIRONMENT_LEVEL.online,
        envsHost: 'ku.baidu.com',
    },
    {
        match: 'ku-qa3.dev.weiyun.baidu.com',
        replaceHost: 'ku-qa3-external.dev.weiyun.baidu.com',
    },
    {
        match: 'rte.weiyun.baidu.com',
        replaceHref: ['rte.weiyun.baidu.com', 'office-service.baidu.com/rte-online'],
        envs: ENVIRONMENT_LEVEL.gray,
        envsReplace: 'office-service.baidu.com/rte-alpha',
    },
    {
        match: 'rtegray.weiyun.baidu.com',
        replaceHref: ['rtegray.weiyun.baidu.com', 'office-service.baidu.com/rte-alpha'],
        envs: ENVIRONMENT_LEVEL.online,
        envsReplace: 'office-service.baidu.com/rte-online',
    },
    {
        match: 'stability-rte-qa3.dev.weiyun.baidu.com',
        replaceHref: [
            'stability-rte-qa3.dev.weiyun.baidu.com',
            'stability-rte-qa3-external.dev.weiyun.baidu.com',
        ],
    },
];

export const transformSrc = (src: string): string => {
    try {
        const url = new URL(src);
        const urlHref = url.href;
        const matchedRule = reverseMappings.find(rule => urlHref.includes(rule.match));
        const env = process.env.REACT_APP_ENVIRONMENT;

        if (!matchedRule) {
            return url.href;
        }

        if (matchedRule.replaceHost) {
            url.host = env === matchedRule.envs && matchedRule.envsHost
                ? matchedRule.envsHost : matchedRule.replaceHost;
            return url.href;
        }

        if (matchedRule.replaceHref) {
            const [from, to] = matchedRule.replaceHref;
            return url.href.replace(from, env === matchedRule.envs && matchedRule.envsReplace
                ? matchedRule.envsReplace : to);
        }
    } catch (error) {
        console.error(error);
    }
    return src;
};
